<template>
  <div class="room-list-wrapper scrollbar blue-scrollbar">
    <template v-if="roomList.length">
      <RoomItem v-for="item in roomList" :key="item.id" :room-info="item"></RoomItem>
    </template>
    <div v-else class="empty white">暂无房间</div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import RoomItem from './room-item'

  export default {
    data () {
      return {}
    },

    computed: {
      ...mapGetters('gameSocket', [
        'roomList'
      ]),
    },

    methods: {},

    components: {
      RoomItem,
    }
  }
</script>

<style lang="stylus" scoped>
  .room-list-wrapper
    padding-top 2px
    height calc(100% - 36px + 1px - 40px)
    overflow-y auto
    .empty
      padding-top 5px
      line-height 20px
      font-size 12px
      text-align center
      letter-spacing 1px

</style>
